module.exports = __webpack_public_path__ + "a41031174f2f979995bd2ab3d19da300.png";